import { useGuardarConfiguracion } from './useGuardarConfiguracion';
import { ConfigCard, AvisoDeGuardado } from './ConfigCard';

/**
 * De dónde sale el árbol de unidades organizacionales.
 *
 * 🔴 El estado de SuccessFactors se muestra **en modo lectura**, y a propósito. Los dos
 * interruptores (habilitado / simulación) gobiernan también la corrida de OUs, pero se cambian en la
 * pestaña de usuarios: un mismo valor con dos mandos acaba en dos mandos que se contradicen. Y no
 * mostrarlo aquí sería peor todavía — alguien vería la corrida de OUs «saltada» sin nada en pantalla
 * que explique por qué.
 */
export function OuSourceCard() {
  const { t, data, isLoading, isError, guardando, guardar, aviso, mensajeDeError } = useGuardarConfiguracion();

  if (isLoading) return <p className="jobs-card-hint" role="status">{t('common.loading')}</p>;
  if (isError || !data) return <p className="jobs-alert jobs-alert--bad" role="alert">{t('jobs.sync.loadError')}</p>;

  const estadoSf = !data.successFactors.enabled
    ? t('jobs.sync.sfOff')
    : data.successFactors.dryRun
      ? t('jobs.sync.sfDryRun')
      : t('jobs.sync.sfOn');

  return (
    <ConfigCard
      icono="fa-sitemap"
      titulo={t('jobs.sync.ous')}
      descripcion={t('jobs.sync.ousDesc')}
      pie={
        <>
          <AvisoDeGuardado aviso={aviso} error={mensajeDeError} />
          {data.updatedBy && (
            <p className="jobs-card-meta">{t('jobs.sync.updatedBy')} {data.updatedBy}</p>
          )}
        </>
      }
    >
      <fieldset className="jobs-fieldset" disabled={guardando}>
        <legend>{t('jobs.sync.ouSource')}</legend>
        <label className="jobs-choice">
          <input
            type="radio"
            name="ouSource"
            checked={data.ouSource === 'Ad'}
            onChange={() => guardar({ ouSource: 'Ad' }, t('jobs.sync.saved'))}
          />
          <span><strong>{t('jobs.sync.ouAd')}</strong></span>
        </label>
        <label className="jobs-choice">
          <input
            type="radio"
            name="ouSource"
            checked={data.ouSource === 'Api'}
            onChange={() => guardar({ ouSource: 'Api' }, t('jobs.sync.saved'))}
          />
          <span><strong>{t('jobs.sync.ouApi')}</strong></span>
        </label>
      </fieldset>

      <div className="jobs-card-row">
        <span>{t('jobs.sync.sf')}</span>
        <strong>{estadoSf}</strong>
      </div>
      <p className="jobs-card-meta">{t('jobs.sync.sfManagedInUsers')}</p>
    </ConfigCard>
  );
}
